module.exports = __webpack_public_path__ + "static/media/medalla-plata.41410426.png";